export default "__VITE_ASSET__662f7140__"